//LOADER
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';

//SEARCH FOR A PHOTO
export const SEARCH_PHOTOS_RECIEVE = 'SEARCH_PHOTOS_RECIEVE';
export const SEARCH_PHOTOS_REQUEST = 'SEARCH_PHOTOS_REQUEST';


//DOWNLOAD A PHOTO
export const DOWNLOAD_A_PHOTO_REQUEST = 'DOWNLOAD_A_PHOTO_REQUEST';
export const DOWNLOAD_A_PHOTO_RECIEVE = 'DOWNLOAD_A_PHOTO_RECIEVE';

/* PHOTOGRAPHER PROFILE */
//PHOTOS
export const PHOTOGRAPHER_PROFILE_REQUEST = 'FEATURED_COLLECTIONS_REQUEST';
export const PHOTOGRAPHER_PROFILE_RECIEVE = 'FEATURED_COLLECTIONS_RECIEVE';

//LIKES
export const PHOTOGRAPHER_LIKES_REQUEST = 'FEATURED_LIKES_REQUEST';
export const PHOTOGRAPHER_LIKES_RECIEVE = 'FEATURED_LIKES_RECIEVE';

//COLLECTIONS
export const PHOTOGRAPHER_COLLECTIONS_REQUEST = 'PHOTOGRAPHER_COLLECTIONS_REQUEST';
export const PHOTOGRAPHER_COLLECTIONS_RECIEVE = 'PHOTOGRAPHER_COLLECTIONS_RECIEVE';